<div class="layout-breadcrumb-container p-d-flex p-ai-center p-jc-between">
    <div class="layout-breadcrumb-left-items p-d-flex p-ai-center">
       <img style="padding-left: 30px; height: 150; width: 250px;" src="assets/elevator_logo.png"/>
        <div style="text-align: left;">
            <h3 style="padding-left: 30px; margin-bottom: 0px; margin-top: 0px; font-size: 3rem; color: #7EAE0B;">Seja bem vindo!</h3>
            <br>
            <h4 style="padding-left: 30px; margin-bottom: 0px; margin-top: 5px; font-size: 1.5rem; color:#E60000;">NOME: {{user.nome_fantasia}}</h4>
            <!-- <h4 style="padding-left: 30px; margin-bottom: 0px; margin-top: 0px; color:#E60000;">{{user.tipo_end}} {{user.end_rps}}, {{user.numero}}</h4> -->
            <h4 style="padding-left: 30px; margin-bottom: 0px; margin-top: 0px; font-size: 1.5rem; color: blue;">CONTRATO: {{user.contrato}}</h4>
         </div>
          <!-- <p-breadcrumb [model]="items" styleClass="layout-breadcrumb p-py-2"></p-breadcrumb> -->
    </div>
    <!-- <div class="layout-breadcrumb-right-items p-d-flex">
        <a tabindex="0" class="search-icon" (click)="appMain.searchActive = true; appMain.searchClick = true;">
            <i class="pi pi-search"></i>
        </a>

        <div class="search-wrapper" [ngClass]="{'active-search-wrapper': appMain.searchActive}">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input type="text" pInputText placeholder="Search..." [(ngModel)]="search" (click)="appMain.searchClick=true"/>
            </span>
        </div>

        <button pButton pRipple type="button" label="Today" icon="pi pi-bookmark" *ngIf="!appMain.isMobile()"
                class="layout-rightmenu-button" (click)="appMain.onRightMenuButtonClick()"></button>
        <button pButton pRipple type="button" icon="pi pi-bookmark" *ngIf="appMain.isMobile()"
                class="layout-rightmenu-button" (click)="appMain.onRightMenuButtonClick()"></button>
    </div> -->
    <div style="text-align: right;margin-right: 40px">
        <button pButton pRipple type="button" icon="pi pi-power-off pi-fw" pTooltip="Sair do Sistema"
        class="p-button-rounded p-button-danger" (click)="logout()"></button>
    </div>
</div>

